<template>
  <div class="content">
    <div class="main">

        <div class="container text-center">
          <h2>{{ title }}</h2>
        </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "home",
  components: {
  },
  data() {
    return {
      title: "Music Worksheets"
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
